import moment from "moment/moment";

/**
 * @return {string[]}
 */
export function compareDiffFields(diff, prefix = null) {
	function formatFieldValue(obj, key) {
		if (typeof obj != 'object' || obj === null)
			return `[${key}]`;
		if (key in obj) {
			const date = /^\d{4}-\d{2}-\d{2}/.test(obj[key]) && moment(new Date(obj[key]));
			if (date?.isValid?.()) {
				return date.tz("Australia/Melbourne").format('D/M/YY HH:mm')
			}
			return obj[key];
		}
		return '(not set)';
	}

	// Just show the "to" fields. From sometimes contains a lot of extra stuff that wasn't actually changed
	return diff?.to ? Object.keys(diff?.to)
		// Some records have null in both from and to, so skip those
		.filter(field => !(diff.to[field] === null && diff.fro[field] === null))
		.flatMap(field => {
			const from = formatFieldValue(diff.fro, field);
			const to = formatFieldValue(diff.to, field);

			const path = [prefix, field].filter(Boolean).join('.');
			// value is a nested object (e.g. dets, med, etc)
			if (!Array.isArray(from) && typeof from === 'object' && from !== null) {
				// and we're not already within a level of recursion
				if (prefix === null) {
					// diff the nested object
					return compareDiffFields({fro: from, to}, path);
				}
			}

			// status("active" => "annul")
			return [`${path}(${JSON.stringify(from)} => ${JSON.stringify(to)})`]
		}) : []
}
